var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "total-amount-view d-flex justify-content-start" },
    [
      _c("em", {
        staticClass: "total-amount-view__icon icon-block",
        class: [_vm.icon, _vm.iconColor]
      }),
      _c("div", { staticClass: "d-flex flex-column" }, [
        _c(
          "div",
          { staticClass: "total-amount-view__title color-secondary-6 font-14" },
          [_vm._v(" " + _vm._s(_vm.title) + " ")]
        ),
        _c(
          "div",
          {
            staticClass:
              "total-amount-view__amount color-black font-weight-bold",
            class: _vm.amountClass
          },
          [_vm._v(" " + _vm._s(_vm.amount) + " ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }